import React, { useState, useEffect } from 'react';
import { Polyline, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import { renderToString } from 'react-dom/server'
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Chip } from '@mui/material';

import { setCenter, setZoom } from '../../../features/map/mapSlice';
import {
    trackDetailViewSelector, visibleTracksSelector, highlightedDriveSelector,
    trackPlayerIndexSelector
} from '../../../features/datacenter/historySlice';
import { assetNamesSelector } from '../../../features/assets/assetsSlice';
const iconToolsColor = "Ivory";



const OsmTrackLine = ({ reportID }) => {
    const dispatch = useDispatch();
    const map = useMap();
    const trackData = useSelector(state => state.history.trackData[reportID]);
    const visibleTracks = useSelector(visibleTracksSelector);
    const focussed = useSelector(trackDetailViewSelector) === reportID;
    const trackPlayerIndex = useSelector(trackPlayerIndexSelector);
    const highlightedDrive = useSelector(highlightedDriveSelector);
    const assetNames = useSelector(assetNamesSelector);
    const icon = assetNames && trackData && assetNames[trackData.reqBody.imei] && assetNames[trackData.reqBody.imei].icon;

    const visible = visibleTracks.indexOf(reportID) !== -1 || focussed;
    const stops = trackData && trackData.stops;
    const drives = trackData && trackData.drives;





    //console.log("track", trackData);
    const [vehicleIcon, setVehicleIcon] = useState(null);
    const [vehicleLable, setVehicleLable] = useState(null);

    const [showStopLabel, setshowStopLabel] = useState(null);
    const [showEventLabel, setShowEventLabel] = useState(null);

    const [stopmarks, setStopmarks] = useState([]);
    const [eventmarks, setEventmarks] = useState([]);
    const [startFlag, setStartFlag] = useState(true);
    const [endFlag, setEndFlag] = useState(true);

    const [stopLabel, setStopLabel] = useState(null);
    const [eventLabel, setEventLabel] = useState(null);

     // eslint-disable-next-line
    const [layerGroup, setLayerGroup] = useState(L.layerGroup().addTo(map));

    useEffect(() => {

        if (vehicleIcon) {
            //console.log("removing for replot");
            map.removeLayer(vehicleIcon);
            setVehicleIcon(null);
        }
        if (vehicleLable) {
            map.removeLayer(vehicleLable);
            setVehicleLable(null);
        }
        if (trackData && trackPlayerIndex) {
            const html = renderToString(
                <Chip
                    size="small"
                    style={{
                        backgroundColor: trackData.track[trackPlayerIndex].speed < 30 ? '#3498DB' : trackData.track[trackPlayerIndex].speed < 60 ? '#27AE60' : '#E74C3C',
                        position: 'absolute',
                        left: -0,
                        top: 20,
                    }}
                    label={
                        <span style={{ color: "White" }}>
                            {trackData.track[trackPlayerIndex].speed} Km/h
                        </span>
                    }
                />
            );
            const tic = L.marker([trackData.track[trackPlayerIndex].lat, trackData.track[trackPlayerIndex].lng], {
                rotationAngle: trackData.track[trackPlayerIndex].angle,
                icon: L.icon({
                    iconUrl: `/assets/markers/def140/${icon}`,
                    iconSize: [12, 24],
                    iconAnchor: [8, 15],
                })
            }).addTo(layerGroup);
            const tlbl = L.marker([trackData.track[trackPlayerIndex].lat, trackData.track[trackPlayerIndex].lng], {
                icon: L.divIcon({
                    html: html,
                    iconAnchor: [0, -5],
                    className: 'dummy'
                })
            }).addTo(layerGroup);
            //console.log("Adding icon");
            /*map.addLayer(tic);
            map.addLayer(tlbl);*/
            setVehicleIcon(tic);
            setVehicleLable(tlbl);
            const zoom = map.getZoom();
            dispatch(setCenter({
                lat: trackData.track[trackPlayerIndex].lat, lng: trackData.track[trackPlayerIndex].lng
            }))
            dispatch(setZoom(zoom));

        }


        return () => {
            //console.log("Unmounting comp");
            if (vehicleIcon) {
                //console.log("removing vehicle icons");
                map.removeLayer(vehicleIcon);
                setVehicleIcon(null);
            }
            if (vehicleLable) {
                map.removeLayer(vehicleLable);
                setVehicleLable(null);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trackPlayerIndex])

    useEffect(() => {
        const smark = [];
        let sf = true;
        let ef = true;
        if (stops && stops.length > 0) {
            stops.forEach((s, si) => {
                const oneDay = moment(s.stopStartTime).format('D/M/Y') === moment(s.stopEndTime).format('D/M/Y');
                const timeLabel = oneDay ?
                    `${moment(s.stopStartTime).format('M/D/Y h:mm A')} to ${moment(s.stopEndTime).format('h:mm A')}`
                    :
                    `${moment(s.stopStartTime).format('M/D/Y h:mm A')} to ${moment(s.stopEndTime).format('M/D/Y h:mm A')}`
                const eventLabel = stops.events ? `Events: ${stops.events.length}` : '';
                const address = trackData.track[s.startIndex].address && trackData.track[s.startIndex].address.fmtd_addr;
                const label = `${timeLabel} \n${eventLabel} \n${address}`;
                smark.push({
                    position: {
                        lat: trackData.track[s.startIndex].lat,
                        lng: trackData.track[s.startIndex].lng,
                    },
                    label,
                    timeLabel,
                    durationLabel: s.stopDuration,
                    eventLabel,
                    address,
                    index: si
                })
            })
            sf = stops[0].startIndex !== 0;
            ef = stops[stops.length - 1].endIndex !== trackData.track.length - 1;
        }

        setStopmarks(smark);
        setStartFlag(sf);
        setEndFlag(ef);

        const events = [];
        if (drives && drives.length > 0) {
            drives.forEach(d => {
                if (d.events.length > 0) {
                    d.events.forEach(e => events.push(e));
                }
            })
        }
        const emark = [];
        if (events && events.length > 0) {
            events.forEach((e, ei) => {
                const timeLabel = moment(e.event_time).format('D/M/Y h:mm:ss a');
                const address = trackData.track[e.routeIndex].address && trackData.track[e.routeIndex].address.fmtd_addr;
                emark.push({
                    position: {
                        lat: trackData.track[e.routeIndex].lat,
                        lng: trackData.track[e.routeIndex].lng,
                    },
                    timeLabel,
                    address,
                    eventLabel: `${e.event_desc} ${e.speed} Km/h`,
                    index: ei
                })
            })
        }
        setEventmarks(emark);
    }, [drives, stops, trackData])

    useEffect(() => {
        if (showStopLabel || showStopLabel === 0) {
            //console.log("Mount", showStopLabel, stopLabel);
            if (stopLabel) {
                //console.log("removing old labael");
                map.removeLayer(stopLabel);
            }
            const html = renderToString(
                <div style={{
                    backgroundColor: iconToolsColor,
                    position: 'absolute',
                    left: 10,
                    top: -10,
                    width: '200px',
                    borderRadius: '3px',
                }}>
                    <div style={{ margin: '5px' }}>
                        <div>
                            <b>Parking: {stopmarks[showStopLabel].durationLabel}</b>
                        </div>
                        <div>
                            {stopmarks[showStopLabel].timeLabel}
                        </div>
                        <div>
                            {stopmarks[showStopLabel].eventLabel}
                        </div>
                        <div>
                            {stopmarks[showStopLabel].address}
                        </div>
                    </div>
                </div>
            );
            const stplbl = L.marker(stopmarks[showStopLabel].position, {
                icon: L.divIcon({
                    html: html,
                    iconAnchor: [-10, -15],
                    className: 'dummy'
                })
            }).addTo(layerGroup);
            //map.addLayer(stplbl);
            setStopLabel(stplbl);

        } else {
            if (stopLabel) {
                map.removeLayer(stopLabel);
                setStopLabel(null);
            }
        }

        return () => {
            if (stopLabel) {
                map.removeLayer(stopLabel);
                setStopLabel(null);
            }
        }

        //dependency array truncated to prevent infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showStopLabel])

    useEffect(() => {
        if (showEventLabel) {
            //console.log("Mount", showEventLabel, eventmarks[showEventLabel]);
            if (eventLabel) {
                map.removeLayer(eventLabel);
            }
            const html = renderToString(
                <div style={{
                    backgroundColor: iconToolsColor,
                    position: 'absolute',
                    left: 10,
                    top: -10,
                    width: '200px',
                    borderRadius: '3px',
                    margin: '5px',
                }}>
                    <div style={{ margin: '5px' }}>
                        <div>
                            <b>{eventmarks[showEventLabel].eventLabel}</b>
                        </div>
                        <div>
                            {eventmarks[showEventLabel].timeLabel}
                        </div>
                        <div>
                            {eventmarks[showEventLabel].address}
                        </div>
                    </div>
                </div>
            );
            const stplbl = L.marker(eventmarks[showEventLabel].position, {
                icon: L.divIcon({
                    html: html,
                    iconAnchor: [-10, -15],
                    className: 'dummy'
                })
            }).addTo(layerGroup);
            //map.addLayer(stplbl);
            setEventLabel(stplbl);

        } else {
            if (eventLabel) {
                map.removeLayer(eventLabel);
                setStopLabel(null);
            }
        }

        return () => {
            if (eventLabel) {
                map.removeLayer(eventLabel);
                setEventLabel(null);
            }
        }
        //dependency array truncated to prevent infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showEventLabel])

    useEffect(() => {

        return () => {
            //console.log("Unmounting comp");
            layerGroup.clearLayers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (trackData && trackData.track && trackData.track.length > 0 && visible) {
        const trackPath = trackData.track.map(t => ([t.lat, t.lng]));
        const trackColor = trackData.trackColor;
        let highlightPath = null;
        if (focussed && highlightedDrive.startIndex && highlightedDrive.endIndex) {
            highlightPath = [];
            trackData.track.forEach((t, i) => {
                if (i >= highlightedDrive.startIndex && i <= highlightedDrive.endIndex) {
                    highlightPath.push([t.lat, t.lng]);
                }
            })
        }
        return (
            <div>
                {
                    focussed &&
                    <Polyline
                        positions={trackPath}
                        pathOptions={{
                            color: trackColor,
                            weight: focussed ? highlightPath ? 1 : 3 : 2,
                            opacity: focussed ? highlightPath ? 0.75 : 1 : 1,
                        }}
                    />
                }
                {
                    highlightPath && highlightPath.length > 0 &&
                    <Polyline
                        positions={highlightPath}
                        pathOptions={{
                            color: trackColor,
                            weight: 4,
                            opacity: 1,
                        }}
                    />
                }
                {
                    startFlag &&
                    <Marker
                        position={[trackData.track[0].lat, trackData.track[0].lng,]}
                        icon={L.icon({
                            iconUrl: `/assets/history/def30/mapmarkergreen.png`,
                            iconAnchor: [15, 30]
                        })}
                    />
                }
                {
                    endFlag &&
                    <Marker
                        position={[trackData.track[trackData.track.length - 1].lat, trackData.track[trackData.track.length - 1].lng,]}
                        icon={L.icon({
                            iconUrl: `/assets/history/def30/mapmarker.png`,
                            iconAnchor: [15, 30]
                        })}
                    />
                }
                {
                    stopmarks.map((s, i) =>
                        <Marker
                            key={`${i}_stop`}
                            position={s.position}
                            icon={L.icon({
                                iconUrl: showStopLabel === i ? `/assets/history/def40/parking.png` : `/assets/history/def30/parking.png`,
                                iconAnchor: [15, 30]
                            })}
                            eventHandlers={{ click: (e) => setshowStopLabel(showStopLabel === i ? null : i) }}
                        />
                    )
                }
                {
                    eventmarks.map((s, i) =>
                        <Marker
                            key={`${i}_stop`}
                            position={s.position}
                            icon={L.icon({
                                iconUrl: showEventLabel === i ? `/assets/history/def40/parking.png` : `/assets/history/def30/parking.png`,
                                iconAnchor: [15, 30]
                            })}
                            eventHandlers={{ click: (e) => setShowEventLabel(showEventLabel === i ? null : i) }}
                        />
                    )
                }

            </div>
        );
    } else {
        return null;
    }




}

export default OsmTrackLine;